// extracted by mini-css-extract-plugin
export var arrows = "_5t-6";
export var decrementer = "_5t-a";
export var disabled = "_5t-4";
export var error = "_5t-1";
export var hiddenText = "_5t-b";
export var incrementer = "_5t-9";
export var input = "_5t-8";
export var inputWrapper = "_5t-0";
export var leadingIcon = "_5t-c";
export var readonly = "_5t-3";
export var regular = "_5t-7";
export var small = "_5t-5";
export var warning = "_5t-2";